import { CLEAR_ALERT } from 'actions/alerts/AlertsActionsTypes';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import {
    ONLINE_BOOKING_NAVIGATE_TO_STEP,
    OnlineBookingAction
} from 'actions/onlineBooking/OnlineBookingActionsTypes';

export const onlineBookingMiddleware: Middleware =
    ({ getState }: MiddlewareAPI<Dispatch<RootAction>, RootState>) =>
    (dispatch: Dispatch<RootAction>) =>
    (action: OnlineBookingAction) => {
        const state = getState();

        if (
            action.type === ONLINE_BOOKING_NAVIGATE_TO_STEP &&
            state.onlineBooking.currentStep !== action.payload.step
        ) {
            dispatch({
                type: CLEAR_ALERT
            });
        }

        return dispatch(action);
    };
